import type { DebugManager } from '../debug-manager.class';

export interface SetVisibleParams {
	visible: boolean;
}

/**
 * Set visibility of all debug objects
 */
export const setVisibleCfn = (
	self: DebugManager,
	{ visible }: SetVisibleParams
): void => {
	self.setVisibilityState(visible);

	// Update sphere visibility
	for (const sphere of self.spheres.values()) {
		sphere.visible = visible;
	}

	// Update line visibility
	for (const line of self.lines.values()) {
		line.visible = visible;
	}

	// Update circle visibility
	for (const circle of self.circles.values()) {
		circle.visible = visible;
	}

	// Update wireframe visibility
	for (const wireframe of self.wireframes.values()) {
		wireframe.visible = visible;
	}

	// Enable/disable hover detection based on visibility
	if (visible) {
		self.enableHoverDetection();
	} else {
		self.disableHoverDetection();
		// Hide all tooltips when not visible
		for (const tooltip of self.tooltips.values()) {
			tooltip.style.display = 'none';
		}
	}
};

/**
 * Clear all debug objects
 */
export const clearCfn = (
	self: DebugManager
): void => {
	// Clear spheres
	for (const id of [...self.spheres.keys()]) {
		self.removeSphere(id);
	}

	// Clear lines
	for (const id of [...self.lines.keys()]) {
		self.removeLine(id);
	}

	// Clear circles
	for (const id of [...self.circles.keys()]) {
		self.removeCircle(id);
	}

	// Clear wireframes
	for (const id of [...self.wireframes.keys()]) {
		self.removeWireframe(id);
	}
};

/**
 * Dispose of all resources
 */
export const disposeCfn = (
	self: DebugManager
): void => {
	// Disable hover detection first
	self.disableHoverDetection();

	self.clear();

	// Remove all tooltips from DOM
	for (const tooltip of self.tooltips.values()) {
		if (tooltip.parentElement) {
			tooltip.parentElement.removeChild(tooltip);
		}
	}
	self.clearTooltips();
};
